
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1np5w_1q93l_5"
};
  